import { useEffect, useRef, useState } from 'react';

/**
 * Debounce a boolean so it only reports `true` after the input has stayed
 * truthy for `delayMs`. Flips back to `false` immediately when the input
 * becomes falsy.
 *
 * Use to gate loading skeletons: a fast operation (sub-`delayMs`) never
 * shows its skeleton, so the UI renders the content directly instead of
 * flashing the loading state for a few frames ("blink"). Slow operations
 * still surface the skeleton once the delay elapses.
 */
export default function useDelayedFlag(value, delayMs = 160) {
  const [delayed, setDelayed] = useState(false);
  const timerRef = useRef(null);

  useEffect(() => {
    if (value) {
      timerRef.current = window.setTimeout(() => setDelayed(true), delayMs);
      return () => window.clearTimeout(timerRef.current);
    }
    setDelayed(false);
    return undefined;
  }, [value, delayMs]);

  return delayed;
}
